module.exports = __webpack_public_path__ + "img/Infografis_EN_05.453250d6.jpg";